<template>
  <div id="login-wrap">
    <div class="container">
      <div class="logo"><img src="../../assets/image/Upload/logo.png"/></div>
      <div class="mobile_verification_part">
        <div class="item">
          <input type="tel" v-model="mobile" placeholder="请输入手机号码" class="mobile_in" maxlength="11" @blur="blur"/>
        </div>
        <div class="item">
          <input type="number" v-model="vCode" placeholder="请输入验证码" class="code_in"  maxlength="6" @blur="blur"/>
          <button @click="getCode" v-html="vCodeStr"></button>
        </div>
      </div>
      <button class="login-btn" @click="login">登录</button>
      <div class="version"><p>Ver：1.0.0</p></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import common from '../../utils/common'
  import VueCookies from 'vue-cookies'
  Vue.use(VueCookies)
  export default {
    name: 'login_upload',
    data() {
      return {
        // 手机 登录
        mobile: '',
        vCode: null,
        vCodeStr: '获取验证码'
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      VueCookies.remove("tokenflag")
      sessionStorage.removeItem("lasterpidc")
      sessionStorage.removeItem("lastresult")
    },
    methods: {
      /* ios页面回落 */
      blur(e) {
        common.blurPageScroll()
      },
      // 获取验证码
      getCode(e) {
        common.getVCodeAdmin(this, e)
      },

      /* 登录 */
      login() {
        const that = this
        if(common.isEmpty(common.trimAll(that.mobile))) {
          common.tipToast('请输入手机号码')
          return
        }
        if(common.trimAll(that.mobile).length != 11) {
          common.tipToast('手机号码格式不正确')
          return
        }
        if(common.isEmpty(common.trimAll(that.vCode))) {
          common.tipToast('请输入验证码')
          return
        }
        if(common.trimAll(that.vCode).length != 6 && common.trimAll(that.vCode).length != 4) {
          common.tipToast('验证码格式不正确')
          return
        }
        const grant_type = 'mobile';
        let data = {mobile: 'SMS@' + that.mobile, code: that.vCode, grant_type}
        that.$axios({
          method: 'post',
          url: '/auth/mobile/token/sms',
          params:  data,
          headers: {
            'Authorization': 'Basic aWJhY2tlbmQ6Y2FuZ29pdDIwMTkwMTAx',
          },
        }).then(function (res) {
          // 以秒为单位，设置1天过去
          VueCookies.set("tokenflag", true, 7195)
          sessionStorage.setItem("access_token", res.data.access_token)
          common.redirect(that, 'result')
        })
      }
    }
  }
</script>

<style scoped>
  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;
  }
  html {
    background-color: #fff;
  }
  #login-wrap{
    width: 100vw;
  }

  #login-wrap > .container {
    margin: 1.13rem auto 0 auto;
    width: 7.5rem;
  }

  #login-wrap > .container > .logo {
    margin: 0 auto;
    width: 3.21rem;
    height: 1.14rem;
    font-size: 0;
  }
  #login-wrap > .container > .logo > img {
    width: 100%;
    height: 100%;
  }
  #login-wrap > .container > .sys_name {
    margin: 0.1rem 0 0 0.7rem;
    width: 1.87rem;
    font-size: 0.20rem;
    line-height: 0.2rem;
    color: #999;
    text-align: justify;
  }
  #login-wrap > .container > .sys_name:after {
    content: " ";
    display: inline-block;
    width: 100%;
  }

  #login-wrap > .container > .mobile_verification_part > .item{
    margin: 0.49rem auto 0 auto;
    padding-bottom: 0.04rem;
    width: 6.10rem;
    background-color: #f4f4f4;
    background-image: none;
    border-radius: 0.02rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item > input {
    padding: 0;
    width: 100%;
    height: 0.72rem;
    line-height: 0.32rem;
    display: block;
    font-size: 0.28rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #222222;
    outline: none;
    border-width: 0;
    border-radius: 0.02rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item:first-child {
    margin-top: 0.81rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item:last-child{
    display: flex;
    flex-flow: row nowrap;
  }
  #login-wrap > .container > .mobile_verification_part > .item:last-child > input {
    min-width: 60%;
    height: 0.72rem;
    line-height: 0.32rem;
  }
  #login-wrap > .container > .mobile_verification_part > .item:last-child > button {
    padding: 0;
    margin: 0;
    min-width: 30%;
    font-size: 0.26rem;
    height: 0.72rem;
    line-height: 0.72rem;
    text-align: right;
    font-weight: normal;
    font-stretch: normal;
    color: #54B4FF;
    background-color: #fff;
    border-width: 0;
    outline: none;
  }
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #B0B6C3
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #B0B6C3;
  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #B0B6C3;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #B0B6C3;
  }

  #login-wrap > .container > .login-btn {
    padding: 0;
    margin: 1.82rem auto 0 auto;
    width: 6.1rem;
    height: 0.9rem;
    font-size: 0.3rem;
    color: #FFFFFF;
    display: block;
    border-width: 0;
    background: #54B4FF;
  }

  .version {
    margin-top: 0.2rem;
    width: 100%;
  }
  .version > p {
    text-align: center;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/Upload/LoginUpload.vue